module.exports = __webpack_public_path__ + "img/ic_iim-arrow-back.svg";